import { render, staticRenderFns } from "./BetalingSimulatie.vue?vue&type=template&id=288bfcb4&"
import script from "./BetalingSimulatie.vue?vue&type=script&setup=true&lang=js&"
export * from "./BetalingSimulatie.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports